<template>
    <section class="hero-slider container-fluid">

        <div id="carouselHERO-Indicators"
             class="carousel slide h-100">
            <div class="carousel-inner">
                <carousel :per-page="1"
                          :mouse-drag="true"
                          :navigationEnabled="true"
                          ref="productDetails">
                    <slide v-for="(banner, index) in banners"
                           v-bind:key="index">
                        <div class="banner-image">
                            <img :src="banner.image" 
                                  alt="banner image"/>
                            <div class="carousel-caption">
                                <div class="container">
                                    <div class="row no-gutters">
                                        <div v-if="banner.title"
                                             class="col-12">
                                            <h1 class="carousel-caption-title text-secondary">{{banner.title}}</h1>
                                        </div>
                                        <div v-if="banner.button.title"
                                             class="col-6 col-sm-4 col-md-3 col-lg-2">
                                            <a v-bind:href="banner.button.link"
                                               class="btn btn-success btn-lg btn-block open-offCanvas">{{banner.button.title}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </slide>
                </carousel>
            </div>

            <a v-if="banners.length > 1"
               class="carousel-control-prev"
               href="#"
               role="button"
               @click="SlideCarousel('prev')">
                <i class="material-icons">keyboard_arrow_left</i>
                <span class="sr-only">Previous</span>
            </a>
            <a v-if="banners.length > 1"
               class="carousel-control-next"
               href="#"
               role="button"
               @click="SlideCarousel('next')">
                <i class="material-icons">keyboard_arrow_right</i>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </section>
</template>

<script>
    import {Carousel, Slide} from 'vue-carousel'
    import {fetchBanners} from "@/services/api";

    export default {
        components: {
            Carousel,
            Slide
        },
        data() {
            return {
                banners: []
            }
        },
        created() {
        this.fetchList();
         
        },
        methods: {
           async fetchList() {
                try{
                const res = await fetchBanners()
                    if(res.length){
                         for (let value of res) {
                            if (value.page === this.$route.name) {
                                 this.banners.push(value)
                             }
                         }
                    }
                }catch(e){
                    return this.banners = []
                }
                //fallback image
                        if (!this.banners.length) {
                            let bannerObj = {};
                            bannerObj.image = 'https://cdn.trailfinders.com/img_0929_lr.jpg';
                            bannerObj.title = this.$route.name.toUpperCase();
                            bannerObj.button = {
                                title: null,
                                link: null
                            };
                            this.banners.push(bannerObj)
                           
                        }
                  
            },
            SlideCarousel(value) {
                const carousel = this.$refs['productDetails'];
                const currentPage = carousel.currentPage;
                const pageCount = carousel.pageCount;
                if (value === 'prev') {
                    currentPage !== 0 ? carousel.goToPage(currentPage - 1) : carousel.goToPage(pageCount - 1);
                } else {
                    currentPage < pageCount - 1 ? carousel.goToPage(currentPage + 1) : carousel.goToPage(0);
                }
            },
        }
    };
</script>

<style scoped>
    .banner-image {
        height: inherit;
        background-size: cover;
        background-position: center;
    }

    .VueCarousel-slide {
        position: relative;
        height: 300px;
    }

    @media (min-width: 768px) {
        .VueCarousel-slide {
            height: 400px;
        }
    }

    @media (min-width: 992px) {
        .VueCarousel-slide {
            height: 500px;
        }
    }

    @media (min-width: 1360px) {
        .VueCarousel-slide {
            height: 600px;
        }
    }

    @media (min-width: 1680px) {
        .VueCarousel-slide {
            height: 760px;
        }
    }
</style>